import { render, staticRenderFns } from "./LeftMenuRl.vue?vue&type=template&id=0a58e4cb&"
import script from "./LeftMenuRl.vue?vue&type=script&lang=js&"
export * from "./LeftMenuRl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports